import React, { Component } from 'react';
import Media from "react-media";
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { SCREEN_WIDTH } from '../../App.js';
import { translate } from 'react-i18next';

class Events extends Component {

  getEventLink = (event) => {
    return {
      pathname: "/events/" + event.id,
      state: {
        center: JSON.stringify(this.props.center),
        event: JSON.stringify(event)
      }
    };
  }

  renderEvent = (event, index) => {
    const endDate = moment(event.end_date, 'YYYY-MM-DD HH:mm:ss');
    const startDate = moment(event.start_date, 'YYYY-MM-DD HH:mm:ss');
    const { t } = this.props;

    return (
      <div className="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-6 card-panel-history" key={index}>
        <div className="card-panel panel panel-default card">
          <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + event.picture + "')" }}>
          </div>
          <div className="card-panel-body">
            <div className="panel-body-title">
              <h4 className="ioscentro">{event.name.toUpperCase()}</h4>
              <h4 className="iossala">{event.center_name}</h4>
            </div>
            <div className="panel-body-description">
              <div className="panel-description-text">
                {event.summary}
              </div>
              <div className="contenedor-flexbox">
                <div className="contenedor-event">
                  <i className="fa fa-calendar" aria-hidden="true"></i>
                  {startDate.format('LL')}
                </div>
                <div className="contenedor-event">
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                  {startDate.format('HH:mm')} - {endDate.format('HH:mm')}
                </div>

              </div>
              <div className="contenedor-flexbox">
                <div className="contenedor-event">
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  {event.center_city}
                </div>
              </div>
            </div>
            <div className="panel-body-bottom">
              <div className="panel-body form-group">
                <Link to={this.getEventLink(event)}>
                  <button
                    className="btn btn-block btn-primary btn-singup btn_create"
                    type="button">
                    {t('dashboard.events.btn_info')}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const events = this.props.events;
    return (
      <div className="list-card-events">
        <div className="list-card-panel-seccion">
          <div className="content-card-panel-seccion">
            <Media query={"(min-width: " + SCREEN_WIDTH.LARGE + "px)"}>
              {(matches) =>
                matches ? (
                  events.map((_, index) => !(index % 2) &&
                    <div className="row list" key={index}>
                      {this.renderEvent(events[index], index)}
                      {events[index + 1] && this.renderEvent(events[index + 1], index + 1)}
                    </div>
                  )
                ) : (
                  events.map((_, index) => !(index % 2) &&
                    <div className="row list" key={index}>
                      {this.renderEvent(events[index], index)}
                      {events[index + 1] && this.renderEvent(events[index + 1], index + 1)}
                    </div>
                  )
                )
              }
            </Media>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Events);



// WEBPACK FOOTER //
// ./src/dashboard/events/Events.js